import { render, staticRenderFns } from "./StudentLeaderBoardDialog.vue?vue&type=template&id=0ec93412"
import script from "./StudentLeaderBoardDialog.vue?vue&type=script&lang=js"
export * from "./StudentLeaderBoardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports